import './selfie.dish.styles.scss';
export default function SelfieDishComponent({ label, type }: { label?: string, type: string }) {

    return <div className='SelfieDishComponent'>
        <em>{type}</em>
    </div>

}